import { render, staticRenderFns } from "./Suche.vue?vue&type=template&id=362c6780&scoped=true"
import script from "./Suche.vue?vue&type=script&lang=js"
export * from "./Suche.vue?vue&type=script&lang=js"
import style0 from "./Suche.vue?vue&type=style&index=0&id=362c6780&prod&scoped=true&lang=css"
import style1 from "./Suche.vue?vue&type=style&index=1&id=362c6780&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c6780",
  null
  
)

export default component.exports